<script lang="ts" setup>
import type { Category } from "~/models/Category"
import { SUPPORTED_PAGES_ENUM } from "~/common/breadCrumbs"
import { useCategoriesStore } from "~/stores/categoriesStore"

/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const i18n = useI18n()
const router = useRouter()

const categoriesStore = useCategoriesStore()
const shopListStore = useShopListStore()

const menuItems = [
    {
        route: "/shopping_card",
        name: "Tarjeta de Compra",
        page: SUPPORTED_PAGES_ENUM.ShoppingCard,
    },
    {
        route: "/info",
        name: i18n.t("home.about_us"),
        page: SUPPORTED_PAGES_ENUM.AboutUs,
    },
    // {
    //   route: '/',
    //   name: i18n.t('home.blog'),
    //   page: SUPPORTED_PAGES_ENUM.Blog
    // },
    // {
    //   route: '/',
    //   name: i18n.t('home.faq'),
    //   page: SUPPORTED_PAGES_ENUM.FAQ
    // },
    {
        route: "/contact-us",
        name: i18n.t("home.contact_us"),
        page: SUPPORTED_PAGES_ENUM.ContactUs,
    },

    {
        // route: "/",
        route: "/blog",
        name: i18n.t("home.blog"),
        page: SUPPORTED_PAGES_ENUM.Blog,
    },
]

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
function goToStore(category?: Category) {
    handleStoreRedirect(category, shopListStore.currentShop?.slug ?? undefined)
}

const handleStoreRedirect = (category?: Category, url: string = "/store") => {
    if (category) {
        categoriesStore.setCurrentCategorySelected(category.label || "")
        router.push({ path: url, query: { category: category.label } })
    } else {
        router.push({ path: url })
    }
}

const goToOffers = () => {
    router.push({ path: "/offers" })
}
</script>
<template>
    <div class="tw-w-full tw-bg-white md:tw-bg-customGray-100 tw-border-b md:tw-overflow-x-auto">
        <div
            class="tw-w-full tw-h-16 tw-max-h-16 tw-hidden md:tw-flex tw-flex-row tw-justify-between tw-items-center tw-gap-5 max-container md:tw-min-w-max"
        >
            <div
                class="tw-flex tw-w-max tw-items-center tw-gap-5"
            >
                <CustomDropdown
                    class="tw-hidden sm:tw-block"
                    :categories="categoriesStore.categories"
                    :dropdownText="$t('fields.categories')"
                    :loading="categoriesStore.loadingCategories"
                    :loadingText="`Cargando ${$t('fields.categories')}`"
                    :currentSelectedCategory="
                        categoriesStore.currentCategorySelected
                    "
                    @selectCategory="
                        (category: Category) => goToStore(category)
                    "
                />
                <MenuSubHeader :menuItems="menuItems" />
            </div>
            <div
                class="tw-flex tw-items-center tw-justify-end !tw-w-[350px] tw-font-titilium"
            >
                <button
                    @click="goToOffers()"
                    class="tw-z-40 tw-cursor-pointer tw-items-center tw-text-white tw-self-center tw-flex tw-bg-secondary hover:tw-bg-secondary-800 tw-h-10 tw-rounded-full tw-gap-1 tw-px-1 sm:tw-px-4 tw-justify-around tw-flex-wrap"
                >
                    <img
                        src="/public/img/offer.svg"
                        class="!tw-w-4 !tw-h-4"
                        alt="offer"
                    />
                    <span
                        class="tw-font-bold tw-text-xs sm:tw-text-base sm:tw-mr-3"
                        >{{ $t("home.products_in_offer") }}</span
                    >
                    <i class="arrow-right-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="tw-w-4 tw-h-4"
                            fill="currentColor"
                        >
                            <path
                                d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
                            />
                        </svg>
                    </i>
                </button>
            </div>
        </div>
    </div>
</template>
